import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

import { CustomButton } from "../../../../components/ui-kit/CustomButtom";

import { useTranslation } from 'react-i18next';

export const AuthForm2FA = ({
  enable2FA,
  skip2FA,
}) => {

  const { t } = useTranslation();

  return (
    <div className="auth-form-enable2FA">
      <div className="auth-form__header">
        <h2 className="heading heading-1">{t("Enable Two-Factor Authentication")}</h2>
        <p className="heading heading-body-medium">
          {t("Get an additional layer of security to protect your account. You can turn it on & off in profile settings.")}
        </p>
      </div>
      <div className="auth-form__submit">
        <CustomButton
          buttonId="enable-btn"
          text={t("Enable")}
          onClickHandler={() => enable2FA()}
        />
        <CustomButton
          buttonId="skip-btn"
          text={t("Skip")}
          id="skip2FA"
          onClickHandler={() => skip2FA()}
        />
      </div>
    </div>
  );
};

AuthForm2FA.propTypes = {
  enable2FA: PropTypes.func,
  skip2FA: PropTypes.func,
};
